import React from 'react';
import { MessageCircle } from 'lucide-react';
import { translate } from '../../lib/translations';

interface LeagueMessagesProps {
  language: 'en' | 'fr';
}

export function LeagueMessages({ language }: LeagueMessagesProps) {
  return (
    <div className="league-messages">
      <div className="card border shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <MessageCircle size={20} className="text-primary me-2" />
            <h5 className="mb-0">
              {language === 'en' ? 'Welcome to Dynasty Hockey Pool' : 'Bienvenue dans Dynasty Hockey Pool'}
            </h5>
          </div>
          <p className="card-text">
            {language === 'en' 
              ? 'Feel free to provide your suggestions to improve the system in the "System Recommendations" section.'
              : 'N\'hésitez pas à donner vos suggestions pour améliorer le système dans la section "Recommandations Système".'
            }
          </p>
        </div>
      </div>
    </div>
  );
}